(() => {
  const SECTION_SELECTOR = '[data-reviews-carousel]';

  function init(section) {
    if (section.dataset.reviewsCarouselInit === 'true') return;
    section.dataset.reviewsCarouselInit = 'true';

    const track = section.querySelector('[data-reviews-track]');
    const prevBtn = section.querySelector('[data-reviews-prev]');
    const nextBtn = section.querySelector('[data-reviews-next]');
    const countEl = section.querySelector('[data-reviews-count]');
    const barFill = section.querySelector('[data-reviews-bar]');
    if (!track || !prevBtn || !nextBtn) return;

    const total = track.children.length;
    if (total === 0) return;

    let index = 0;

    const perPage = () => {
      const w = window.innerWidth;
      if (w <= 640) return 1;
      if (w <= 1024) return 2;
      return 3;
    };
    const maxIndex = () => Math.max(0, total - perPage());
    const pad = (n) => String(n).padStart(2, '0');

    const update = () => {
      const pp = perPage();
      const max = maxIndex();
      if (index > max) index = max;

      track.style.transform = `translateX(-${index * (100 / pp)}%)`;

      if (countEl) {
        const lastVisible = Math.min(total, index + pp);
        countEl.textContent = `${pad(lastVisible)} / ${pad(total)}`;
      }
      if (barFill) {
        const progress = max === 0
          ? 100
          : (index / max) * (1 - pp / total) * 100 + (pp / total) * 100;
        barFill.style.width = progress + '%';
      }

      prevBtn.disabled = index === 0;
      nextBtn.disabled = index >= max;
      prevBtn.setAttribute('aria-disabled', String(prevBtn.disabled));
      nextBtn.setAttribute('aria-disabled', String(nextBtn.disabled));
    };

    const go = (delta) => {
      const pp = perPage();
      index = Math.max(0, Math.min(maxIndex(), index + delta * pp));
      update();
    };

    prevBtn.addEventListener('click', () => go(-1));
    nextBtn.addEventListener('click', () => go(1));

    // Keyboard ←/→ when section is in viewport
    let inView = false;
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => (inView = e.isIntersecting)),
      { threshold: 0.25 }
    );
    io.observe(section);

    document.addEventListener('keydown', (e) => {
      if (!inView) return;
      if (e.key === 'ArrowLeft') go(-1);
      if (e.key === 'ArrowRight') go(1);
    });

    // Touch swipe
    let touchStartX = null;
    track.addEventListener(
      'touchstart',
      (e) => {
        touchStartX = e.touches[0].clientX;
      },
      { passive: true }
    );
    track.addEventListener(
      'touchend',
      (e) => {
        if (touchStartX == null) return;
        const dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 40) go(dx > 0 ? -1 : 1);
        touchStartX = null;
      },
      { passive: true }
    );

    // Resize re-clamp
    const ro = new ResizeObserver(() => update());
    ro.observe(section);

    update();
  }

  const initAll = () => document.querySelectorAll(SECTION_SELECTOR).forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor section reload
  document.addEventListener('shopify:section:load', (e) => {
    const sec = e.target.querySelector(SECTION_SELECTOR);
    if (sec) init(sec);
  });
})();
